const article = `
{settings}
document.title: Allt du behöver veta om brexit – och lite till
og.title: Allt du behöver veta om brexit – och lite till
og.image: http://quickshot.imgix.net/brexit/brexit_may.jpg?w=1000
og.description: Britterna lämnar EU. Men vad innebär det? Här är allt du behöver veta om brexit.
og.url: http://pejl.svt.se/brexit/
siteCatalyst.name: brexit
siteCatalyst.category: lyxartikel
{}

[+page]
luft:-48
{.bild}
fil:brexit/brexit_may.jpg
storlek:xlcinema
{}
rubrik: Allt du behöver veta om brexit – och lite till

{.sharebuttons}
title:Allt du behöver veta om brexit – och lite till
url:http://pejl.svt.se/brexit/
{}

rubrik3:Först och främst – vad är brexit?

Brexit är ett kortnamn för Storbritanniens utträde ur EU, som det brittiska folket folkomröstade om den 23 juni 2016. Benämningen är en sammanslagning av orden Britain och exit, på samma sätt som Greklands möjliga utträde ur EU fick namnet grexit.


rubrik3:Vad händer nu?

[1.| tid] Sent på kvällen tisdagen den 28 mars undertecknade Storbritanniens premiärminister Theresa May artikel 50, den formella ansökan om ett utträde ur EU.

[2.| tid] Den 29 mars lämnar Storbritanniens EU-ambassadör Tim Barrow över ansökan om brittiskt utträde till Europeiska rådets ordförande, Donald Tusk.

[3.| tid] Inom ett par dagar ska rådsordföranden Donald Tusk lägga fram förslag till riktlinjer för förhandlingarna. Vid extra EU-toppmöte 29 april ska regeringscheferna i övriga 27 EU-länder fastställa förhandlingsmandatet för EU:s chefsförhandlare Michel Barnier.

[4.| tid] Först i oktober väntas det bli förhandlingar på allvar, efter valen i Frankrike och Tyskland. Reglerna om att lämna EU, artikel 50 i EU:s grundfördrag är kortfattade och allmänt hållna.

[5.| tid] Redan hösten 2018 behöver en uppgörelse vara färdigförhandlad, för att alla medlemsländers parlament och EU-parlamentet sen ska hinna godkänna det hela. Detta för att klara regelverkets tidsgräns på två år för utträdesförhandlingar.

[6.| tid] Britterna ska lämna EU i slutet av mars 2019.




rubrik4:Få brexitkoll – på mindre än 60 sekunder:

video:12929172



rubrik3:Hur blev det så här?

[Motstånd till EU | red]
Storbritanniens medlemskap i EU har varit omstritt sedan landet gick med 1973. 1975 röstade 67 procent i en folkomröstning för att stanna. Olika brittiska regeringar har sedan dess förhandlat fram rabatt på medlemsavgiften och flera undantag. Särskilt i det ledande konservativa partiet finns en stark opinion mot EU.

[Egna regler | red]
Förre premiärministern David Cameron förhandlade i början av 2016 fram fler specialregler. Britterna skulle bland annat inte behöva ge migranter från andra EU-länder sociala förmåner de första fyra åren de arbetar i Storbritannien. Samtidigt utlyste Cameron en folkomröstning om Storbritannien med de nya villkoren skulle stanna eller lämna EU.

[Ny omröstning | red]
Vid folkomröstningen den 23 juni 2016 gav ett delat Storbritannien sitt svar. 52 procent röstade för att lämna EU, 48 procent röstade för att stanna kvar. Över 30 miljoner britter, 71,8 procent, deltog i folkomröstningen.

[Brexit är ett faktum | red]
Efter att resultatet stod klart meddelade Storbritanniens dåvarande premiärminister David Cameron, som drivit att landet skulle stanna kvar i EU, att han skulle avgå. Theresa May efterträdde honom som partiledare för konservativa Torypartiet. May var även hon en förespråkare för att Storbritannien skulle stanna i EU, men är ingen passionerad EU-vän och lovade att respektera folkomröstningen och genomföra brexit.

{.video}
id:9318120
bildtext: Hör David Cameron meddela sin avgång efter brexit-beskedet.
{}




rubrik3:Vad är artikel 50?

Artikel 50 är en del i EU-fördraget, en plan för länder som vill lämna EU. Det skapades i samband med att man skrev under Lissabonfördraget 2009. Innan dess fanns ingen formell plan för hur det skulle gå till om ett land ville träda ut ur Europeiska unionen.
Artikel 50 består av fem paragrafer som i korthet säger att det land som vill lämna EU ska meddela och förhandla ett avtal om utträdet med Europeiska rådet.

Avtalet mellan det land som lämnar och Europeiska rådet ska träffas inom en tidsperiod på två år om inte alla parter är överens om att förlänga det. Det land som väljer att lämna EU får inte, enligt artikel 50, delta i de interna diskussioner som förs i EU om det aktuella landets utträde.

Läs hela [Artikel 50 här|http://www.lissabonfordraget.se/fordraget/eu-fordraget.php#avdelning3].




rubrik3:Vad händer med Skottland?

I Skottland ville en majoritet fortsätta i EU. Samtidigt som regeringen i London nu skickar in sin utträdesanmälan till EU så kommer parlamentet i Skottland rösta om att hålla en ny folkomröstning om skottarna ska lämna Storbritannien.

{.video}
id: 12807704
bildtext: Hör Skottlands ledare Nicola Sturgeon om konsekvenserna av brexit.
{}




rubrik3: Så har opinionen för och emot EU sett ut de senaste åren:

{.iframe}
src: http://datawrapper.dwcdn.net/A9U2S/1/
storlek:m
height:400px
{}

rubrik3: Hur såg argumenten, och väljargrupperna, ut för och emot?


mellanrubrik: Typisk väljare som ville [lämna|red] EU:
{.bild}
fil:brexit/Brexit-Man.jpg
storlek:wide
{}
luft:-48

[.lista-centrerad]
* Man över 60 år
* Grundskoleutbildad
* Skolad yrkesarbetare
* Bor i östra England
* Röstar på Ukip
[]

mellanrubrik: Argumenten från [Lämna|red]-kampanjen:

[.lista]
* Självbestämmande. Vi får bestämma mer själva – istället för byråkrater i Bryssel.
* Vi kan stoppa en massa migranter från fattiga länder i Östeuropa som kommer hit och tar jobb till låga löner eller får bidrag.
* Med handels- och tullavtal får företagen liknande villkor som tidigare men kommer att slippa EU:s alla detaljregler och byråkrati.
[]

luft:200

mellanrubrik: Typisk väljare som ville [stanna|blue] i EU:
{.bild}
fil:brexit/Brexit-Kvinna.jpg
storlek:wide
{}
luft:-48
[.lista-centrerad]
* Kvinna mellan 18-29 år
* Universitetsutbildad
* Medelklass/övre medelklass
* Arbetsledande position
* Bor i Skottland
* Röstar på De Gröna
[]

mellanrubrik: Argumenten från [Stanna|blue]-kampanjen:
[.lista]
* Vi måste i alla fall anpassa oss till en massa EU-regler om våra företag ska få sälja på EU:s marknad, därför är det bättre att vara med och påverka besluten.
* Polacker och andra östeuropéer som är EU-medborgare kommer hit är unga, arbetar och betalar skatt och bidrar till ekonomin.  Möjligheterna att få förmåner och bidrag minskar med den senaste uppgörelsen med EU.
* En familj riskerar att förlora tusentals pund om året i en sämre ekonomi utanför EU. Lämnar vi EU får brittiska företag svårare att sälja och exportera till Europa och utländska företag vill inte investera i Storbritannien.
[]
luft:60px


rubrik3: Vad tycker andra EU-länder om att Storbritannien lämnar?

Från framförallt franska och belgiska politiker har det kommit en del hårdföra uttalanden om att britterna ska "straffas" och få en besvärlig brexit. Från regeringarna i Tyskland, Nederländerna och Sverige har det däremot mer talats om vikten av goda relationer med britterna också i framtiden.
Länder som Tyskland och Sverige har industrier som exporterar mycket till Storbritannien. Den brittiska regeringen har hoppats att bland annat tyskar och svenskar under kommande förhandlingarna ska öppna för förmånliga frihandelsavtal.

[LÄS MER:] [Konflikterna som hotar förhandlingarna | http://www.svt.se/nyheter/utrikes/brexit-guide-fyra-fragor-och-svar-for-att-forsta-vad-som-hander-nu]


Hittills har övriga EU-länder visat sammanhållning. Inga förhandlingar innan brittiska regeringen lämnar in sin formella anmälan och förklarar vad den brittiska sidan vill. Också tyska regeringen har betonat det "måste kosta" och "märkas skillnad" att inte vara EU-medlem.
Regeringarna i Polen och Ungern har samma inställning som britterna i många frågor, men den brittiska folkomröstningskampanjens udd mot östeuropeiska EU-migranter har retat och försvagat britternas stöd i Östeuropa.
Men det är naturligtvis först när nu förhandlingarna verkligen sätter igång som vi ser hur pass enade de övriga 27 EU-länderna är.

mellanrubrik: Här kan du höra vad de svenska partiledarna tyckte om brexit:

video:9319040

rubrik3: Vad händer med EU-medborgare som bor i Storbritannien?

Den brittiska regeringen har inte gett några garantier för de EU-medborgare som är boende i landet och menar att man väntar på att få motsvarande löfte från andra medlemsländer om de miljontals brittiska medborgare som bor i andra EU-länder.
EU-medborgare som har permantent uppehållstillstånd i Storbritannien, ett tillstånd man får efter fem år, kommer inte att påverkas av brexit.
Personer som arbetar, eller vill arbeta, i Storbritannien kommer att få vänta för att få besked om hur de påverkas av brexit. Det beror på vilken slags handelsavtal som förhandlas fram mellan Storbritannien och EU.

[LÄS MER:] [London-svensken Evy Jessica Rune: "Hoppas jag inte blir utvisad"| http://www.svt.se/nyheter/inrikes/efter-brexit-osaker-framtid-for-svenskar-i-storbritannien ]

rubrik3: Till sist, hur fungerar EU egentligen?

[.lista]
* Europeiska unionen, EU, är ett överstatligt samarbete mellan 28 länder som tar gemensamma beslut inom en rad politiska områden.

* Sverige blev medlem i EU 1995, sedan dess har 13 nya länder blivit medlemmar.

* Vilka frågor som ska avgöras av EU diskuteras och förändras ständigt. Ett centralt område är vad som kallas den inre marknaden. Det innebär att EU ska göra det enkelt att sälja och köpa varor, tjänster, arbetskraft och kapital mellan medlemsländerna.

* Andra områden där EU bestämmer helt eller delvis är handel med länder utanför EU, miljö, jordbruk, utrikespolitik, invandring, och brottsbekämpning över gränserna.

* EU-länderna bestämmer själva över sådant som enbart berör det egna landet, till exempel inkomstskatter, sjukvård, skola samt pensioner och barnbidrag.

* När EU fattar beslut sker det i tre organ: EU-kommissionen, Europaparlamentet och Ministerrådet. Dessa tre beslutar om de flesta av EU:s lagar och kan jämföras med Sveriges riksdag och regering.

[]
rubrik4:Läs mer: [Alla SVT:s artiklar om brexit | http://www.svt.se/nyheter/utrikes/13036282 | target:_self ]
linje:

rubrik5: Rolf Fredriksson [ rolf.fredriksson@svt.se | mailto:rolf.fredriksson@svt.se ]
rubrik5: Ella Berger [ ella.berger@svt.se | mailto:ella.berger@svt.se ]
rubrik5: Helena Zachariasson [ helena.zachariasson@svt.se | mailto:helena.zachariasson@svt.se ]
29 mars 2017

{.sharebuttons}
title:Allt du behöver veta om brexit – och lite till
url:http://pejl.svt.se/brexit/
{}
[]
`;

export default article;



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/data/articles/brexit.js
 **/